(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
  var drawer = document.getElementById('rp-cart-drawer');
  if (!drawer) return;

  var overlay  = drawer.querySelector('.rp-cd__overlay');
  var closeBtn = drawer.querySelector('.rp-cd__close');
  var itemsEl  = document.getElementById('rp-cd-items');
  var emptyEl  = document.getElementById('rp-cd-empty');
  var footEl   = document.getElementById('rp-cd-foot');
  var countEls = document.querySelectorAll('.rp-cd__count, .rp-header__cart-count');
  var subtotalEl = document.getElementById('rp-cd-subtotal');

  function openDrawer() {
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  window.RpCart = { open: openDrawer, close: closeDrawer };

  if (overlay) overlay.addEventListener('click', closeDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') closeDrawer();
  });

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 });
  }

  function updateCartUI(cart) {
    var count = cart.item_count;

    document.querySelectorAll('.rp-cd__count').forEach(function (el) {
      el.textContent = '(' + count + ')';
    });
    document.querySelectorAll('.rp-header__cart-count').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
    document.querySelectorAll('.rp-cp__count').forEach(function (el) {
      el.textContent = count;
    });

    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    var cpSubtotal = document.getElementById('rp-cp-subtotal');
    if (cpSubtotal) cpSubtotal.textContent = formatMoney(cart.total_price);

    if (count === 0) {
      if (itemsEl) itemsEl.hidden = true;
      if (emptyEl) emptyEl.hidden = false;
      if (footEl)  footEl.hidden  = true;
      var cpItems = document.getElementById('rp-cp-items');
      var cpEmpty = document.getElementById('rp-cp-empty');
      var cpSummary = document.getElementById('rp-cp-summary');
      if (cpItems) cpItems.hidden = true;
      if (cpEmpty) cpEmpty.hidden = false;
      if (cpSummary) cpSummary.hidden = true;
    } else {
      if (itemsEl) itemsEl.hidden = false;
      if (emptyEl) emptyEl.hidden = true;
      if (footEl)  footEl.hidden  = false;
    }
  }

  function cartChange(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var item = cart.items.find(function (i) { return i.key === key; });
      var articleEl = document.querySelector('[data-item-key="' + key + '"]');
      if (articleEl) {
        if (qty === 0 || !item) {
          articleEl.remove();
        } else {
          var qtyInput = articleEl.querySelector('[data-action="qty-input"]');
          if (qtyInput) qtyInput.value = item.quantity;
          var priceEl = articleEl.querySelector('.rp-ci__price');
          if (priceEl) priceEl.textContent = formatMoney(item.final_price * item.quantity);
        }
      }
      updateCartUI(cart);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-action]');
    if (!btn) return;
    var article = btn.closest('[data-item-key]');
    if (!article) return;
    var key = article.dataset.itemKey;
    var action = btn.dataset.action;
    var qtyInput = article.querySelector('[data-action="qty-input"]');
    var currentQty = qtyInput ? parseInt(qtyInput.value, 10) : 1;

    if (action === 'remove') { cartChange(key, 0); }
    else if (action === 'decrement') { if (currentQty > 1) cartChange(key, currentQty - 1); else cartChange(key, 0); }
    else if (action === 'increment') { cartChange(key, currentQty + 1); }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-action="qty-input"]');
    if (!input) return;
    var article = input.closest('[data-item-key]');
    if (!article) return;
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) return;
    cartChange(article.dataset.itemKey, qty);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
